import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout/index.vue';
import Submenu from '@/views/submenu/index.vue'
import layoutAgent from '@/layoutAgent/index.vue';
import { permissions } from '@/router/vids';
import { checkPermissionCompanyModule } from '@/utils/permission';
import { UserModule } from '@/store/modules/user';
import { Type } from '@/types/permissionType';

Vue.use(Router);

const dynamicRoutes:any = [
  {
    path: '/',
    component: Layout,
    redirect: '/Index',
    meta: {
      title: '报修管家',
      hidden: true
    },
    children: [
      {
        path: 'Index',
        name: 'Index',
        meta: {
          title: '主页',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/IndexNew',
    component: Layout,
    name: 'IndexNew',
    meta: {
      title: '首页',
      icon: 'home',
      Permissions: permissions.index,
      hidden: true
    },
    children: [
      {
        path: 'workIndex',
        name: 'workIndex',
        component: () => (UserModule.company.vip_level && UserModule.company.vip_level.substring(0, 1) !== '1') ? import('@/views/dashboard/indexWorkServicer.vue') : import('@/views/dashboard/indexWork.vue'),
        meta: {
          title: '工作台',
          Permissions: permissions.indexWorkBench,
          hidden: true
        }
      },
      {
        path: 'dashboard',
        name: 'dashboardIndex',
        component: () => import('@/views/dashboard/dashboardIndex.vue'),
        meta: {
          title: '数据看板',
          hidden: true,
          Permissions: permissions.dashBoard
        }
      },
      {
        path: 'indexS',
        name: 'indexS',
        component: () => import('@/views/dashboard/index.vue'),
        meta: {
          title: '首页',
          hidden: true,
          Permissions: permissions.indexS
        }
      },
    ]
  },
  // 工作台编辑
  {
    path: '/indexEdit',
    name: 'workIndexEdit',
    component: () => import('@/views/dashboard/indexWorkEdit.vue'),
    meta: {
      title: '工作台编辑',
      hidden: true,
    }
  },
  // 工作台-服务方，编辑
  {
    path: '/indexEditServicer',
    name: 'workIndexServicerEdit',
    component: () => import('@/views/dashboard/indexWorkEditServicer.vue'),
    meta: {
      title: '工作台编辑',
      hidden: true,
    }
  },
  // 注册
  {
    path: '/register',
    component: () => import(/* webpackChunkName: "register" */ '@/views/register/index.vue'),
    meta: { hidden: true }
  },
  {
    path: '/OrderAll',
    type: '10',
    component: Layout,
    meta: {
      title: '报修管理',
      icon: 'order',
      Permissions: permissions.MyOrderAll,
      hidden: true
    },
    children: [{
      path: '/order',
      component: Submenu,
      meta: {
        title: '我的报修',
        icon: 'order',
        Permissions: permissions.MyOrder,
        hidden: true
      },
      children: [
        {
          path: 'add',
          name: 'OrderAdd',
          type: 'block',
          component: () => import('@/views/order/OrderAdd.vue'),
          meta: {
            title: '添加订单',
            Permissions: permissions.MyOrderAddOrder,
            hidden: true
          }
        },
        {
          path: 'check',
          name: 'OrderCheck',
          component: () => import('@/views/order/OrderCheck.vue'),
          meta: {
            title: '审核中',
            Permissions: permissions.MyOrderCheckOrder,
            hidden: true
          }
        },
        {
          path: 'underway',
          name: 'OrderUnderway',
          component: () => import('@/views/order/OrderUnderway.vue'),
          meta: {
            title: '进行中',
            Permissions: permissions.MyOrderOrder,
            hidden: true
          }
        },
        {
          path: 'unconfirmed',
          name: 'OrderUnconfirmed',
          component: () => import('@/views/order/OrderUnconfirmed.vue'),
          meta: {
            title: '待验收',
            Permissions: permissions.MyOrderOrder,
            hidden: true
          }
        },
        {
          path: 'completed',
          name: 'OrderCompleted',
          component: () => import('@/views/order/OrderCompleted.vue'),
          meta: {
            title: '已完成',
            Permissions: permissions.MyOrderOrder,
            hidden: true
          }
        },
        {
          path: 'orderToDetail',
          name: 'orderToDetail',
          component: () => import('@/views/order/OrderDetail.vue'),
          meta: {
            title: '订单详情',
            hidden: true
          }
        },
        {
          path: 'evaluate',
          name: 'OrderEvaluate',
          component: () => import('@/views/order/OrderEvaluate.vue'),
          meta: {
            title: '订单评价',
            hidden: true
          }
        },
        {
          path: 'evaluateOrder',
          name: 'OrderEvaluate',
          component: () => import('@/views/order/OrderEvaluateNew.vue'),
          meta: {
            title: '订单评价',
            hidden: true
          }
        },
        {
          path: 'send',
          name: 'OrderSend',
          component: () => import('@/views/order/OrderSend.vue'),
          meta: {
            title: '马上寄送',
            hidden: true
          }
        }
      ]
    }, {
      path: '/OrderCustomer',
      component: Submenu,
      meta: {
        title: '所有报修',
        icon: 'ordercustomer',
        Permissions: permissions.ReportOrder,
        hidden: true
      },
      children: [
        {
          path: 'all',
          name: 'OrderCustomerAll',
          component: () => import('@/views/orderCustomer/OrderCustomerAll.vue'),
          meta: {
            title: '所有报修',
            Permissions: permissions.ReportOrderAllOrder,
            hidden: true
          }
        },
        {
          path: 'check',
          name: 'OrderCustomerCheck',
          component: () => import('@/views/orderCustomer/OrderCustomerCheck.vue'),
          meta: {
            title: '审核订单',
            Permissions: permissions.ReportOrderCheckOrder,
            hidden: true
          }
        },
        {
          path: 'underway',
          name: 'OrderCustomerUnderway',
          component: () => import('@/views/orderCustomer/OrderCustomerUnderway.vue'),
          meta: {
            title: '进行中',
            Permissions: permissions.ReportOrderAllOrder,
            hidden: true
          }
        },
        {
          path: 'unconfirmed',
          name: 'OrderCustomerUnconfirmed',
          component: () => import('@/views/orderCustomer/OrderCustomerUnconfirmed.vue'),
          meta: {
            title: '待验收',
            Permissions: permissions.ReportOrderAllOrder,
            hidden: true
          }
        },
        {
          path: 'unevaluated',
          name: 'OrderCustomerUnevaluated',
          component: () => import('@/views/orderCustomer/OrderCustomerUnEvaluated.vue'),
          meta: {
            title: '待评价',
            Permissions: permissions.ReportOrderAllOrder,
            hidden: true
          }
        },
        {
          path: 'completed',
          name: 'OrderCustomerCompleted',
          component: () => import('@/views/orderCustomer/OrderCustomerCompleted.vue'),
          meta: {
            title: '已完成',
            Permissions: permissions.ReportOrderAllOrder,
            hidden: true
          }
        }
      ]
    }, {
      path: '/OrderCheck',
      component: Submenu,
      meta: {
        title: '审核工单',
        icon: 'ordercheck',
        Permissions: permissions.CheckManiger,
        hidden: true
      },
      children: [
        {
          path: 'wait',
          name: 'OrderCheckWait',
          component: () => import('@/views/orderCheck/OrderCheckWait.vue'),
          meta: {
            title: '待审核',
            Permissions: permissions.CheckManigerList,
            hidden: true
          }
        }, {
          path: 'pass',
          name: 'OrderCheckPass',
          component: () => import('@/views/orderCheck/OrderCheckPass.vue'),
          meta: {
            title: '已通过',
            Permissions: permissions.CheckManigerList,
            hidden: true
          }
        }, {
          path: 'refuse',
          name: 'OrderCheckRefuse',
          component: () => import('@/views/orderCheck/OrderCheckRefuse.vue'),
          meta: {
            title: '未通过',
            Permissions: permissions.CheckManigerList,
            hidden: true
          }
        }, {
          path: 'set',
          name: 'OrderCheckSetting',
          component: () => checkPermissionCompanyModule(UserModule.getCompanyId, Type.CheckSettingDept)||checkPermissionCompanyModule(UserModule.getCompanyId, Type.CheckSettingGroup) ? import('@/views/orderCheck/OrderCheckList.vue') : import('@/views/orderCheck/OrderCheckSetting.vue'),
          meta: {
            title: '审核设置',
            Permissions: permissions.CheckManigerSetting,
            hidden: true
          }
        }, {
          path: 'setCheckOrder',
          name: 'OrderCheckSetting',
          component: () => import('@/views/orderCheck/OrderCheckSetting.vue'),
          meta: {
            title: '审核设置',
            hidden: true
          }
        }, {
          path: 'list',
          name: 'OrderCheckList',
          component: () => import('@/views/orderCheck/OrderCheckList.vue'),
          meta: {
            title: '审核流程列表',
            hidden: true
          }
        }
      ]
    }, ]
  },
  // 订单管理 === （订单管理，投诉管理）
  {
    path: '/OrderServicerAll',
    type: '10',
    component: Layout,
    meta: {
      title: '订单管理',
      icon: 'orderservicer',
      Permissions: permissions.ServerOrderAll,
      hidden: true
    },
    children: [{
      path: '/OrderServicer',
      component: Submenu,
      meta: {
        title: '订单列表',
        icon: 'orderservicer',
        Permissions: permissions.ServerOrder,
        hidden: true
      },
      children: [
        {
          path: 'add',
          name: 'OrderServicerAdd',
          component: () => import('@/views/orderServicer/orderServicerAdd.vue'),
          meta: {
            title: '添加订单',
            Permissions: permissions.ServicerOrderAdd,
            hidden: true
          }
        },
        {
          path: 'myAdd',
          name: 'OrderServicerMyAdd',
          component: () => import('@/views/orderServicer/orderServicerAddMy.vue'),
          meta: {
            title: '我添加的',
            Permissions: permissions.MyAddOrders,
            hidden: true
          }
        },
        {
          path: 'all',
          name: 'orderServicerAll',
          type: 'block',
          component: () => import('@/views/orderServicer/orderServicerAll.vue'),
          meta: {
            title: '所有订单',
            Permissions: permissions.ServerOrderAllOrder,
            hidden: true
          }
        },
        {
          path: 'untreated',
          name: 'orderServicerUntreated',
          component: () => import('@/views/orderServicer/orderServicerUntreated.vue'),
          meta: {
            title: '待处理',
            Permissions: permissions.ServerOrderAllOrder,
            hidden: true
          }
        },
        {
          path: 'grab',
          name: 'orderServicerGrab',
          component: () => import('@/views/orderServicer/orderServicerGrab.vue'),
          meta: {
            title: '工单池',
            Permissions: permissions.OrderServicerGrabOrder,
            hidden: true
          }
        }, {
          path: 'underway',
          name: 'orderServicerUnderway',
          component: () => import('@/views/orderServicer/orderServicerUnderway.vue'),
          meta: {
            title: '进行中',
            Permissions: permissions.ServerOrderAllOrder,
            hidden: true
          }
     }, {
          path: 'unconfirmed',
          name: 'orderServiceUnconfirmed',
          component: () => import('@/views/orderServicer/orderServicerUnconfirmed.vue'),
          meta: {
            title: '待确认',
            Permissions: permissions.ServerOrderAllOrder,
            hidden: true
          }
        }, {
          path: 'completed',
          name: 'orderServicerCompleted',
          component: () => import('@/views/orderServicer/orderServicerCompleted.vue'),
          meta: {
            title: '完结单',
            Permissions: permissions.ServerOrderAllOrder,
            hidden: true
          }
        }, {
          path: 'returnvisit',
          name: 'orderServicerReturnVisit',
          component: () => import('@/views/orderServicer/orderServicerReturnVisit.vue'),
          meta: {
            title: '回访',
            hidden: true
          }
        }, {
          path: 'evaluate',
          name: 'OrderServicerEvaluate',
          component: () => import('@/views/orderServicer/orderServicerEvaluate.vue'),
          meta: {
            title: '订单评价',
            hidden: true
          }
        },{
          path: 'evaluation',
          name: 'OrderServicerEvaluateNew',
          component: () => import('@/views/orderServicer/orderServicerEvaluateNew.vue'),
          meta: {
            title: '订单评价',
            hidden: true
          }
        },
        {
          path: 'todealing', // 新版
          name: 'orderServicerTodealing',
          component: () => import('@/views/orderServicer/orderServicerTodealNew.vue'),
          meta: {
            title: '处理订单',
            hidden: true
          }
        },
        {
          path: 'todetail', // 新版
          name: 'orderServicerToDetail',
          component: () => import('@/views/orderServicer/orderServicerToDetail.vue'),
          meta: {
            title: '订单详情',
            hidden: true
          }
        },
        {
          path: 'toquote',
          name: 'orderServicerToquote',
          component: () => import('@/views/orderServicer/orderServicerToquote.vue'),
          meta: {
            title: '生成报价单',
            hidden: true
          }
        }
      ]
    }, {
      path: '/OrderServicer',
      component: Submenu,
      meta: {
        title: '',
        icon: 'orderservicer',
        Permissions: permissions.ServerOrder,
        hidden: true
      },
      children: [{
        path: 'report',
        name: 'orderServicerReport',
        component: () => import('@/views/orderServicer/orderServicerReport.vue'),
        meta: {
          title: '上报中',
          Permissions: permissions.ServerOrderAllOrder,
          hidden: true
        }
      },
      {
        path: 'enquiry',
        name: 'orderServicerEnquiry',
        component: () => import('@/views/orderServicer/orderServicerEnquiry.vue'),
        meta: {
          title: '询价单',
          Permissions: permissions.ServerOrderEnquiry,
          hidden: true
        }
      },
      {
        path: 'timeout',
        name: 'orderServicerTimeout',
        component: () => import('@/views/orderServicer/orderServicerTimeOut.vue'),
        meta: {
          title: '超时单',
          Permissions: permissions.ServerOrder151010,
          hidden: true
        }
      }, {
        path: 'hang',
        name: 'orderServicerHang',
        component: () => import('@/views/orderServicer/orderServicerHang.vue'),
        meta: {
          title: '挂单中',
          Permissions: permissions.ServerOrderAllOrder,
          hidden: true
        }
      }, {
        path: 'refuse',
        name: 'orderServicerRefuse',
        component: () => import('@/views/orderServicer/orderServicerRefuse.vue'),
        meta: {
          title: '拒绝单',
          Permissions: permissions.ServerOrder151010,
          PermissionsOther:parseInt(UserModule.getCompany.is_refuse_accept_complete) == 1 ,
          hidden: true
        }
      }, {
        path: 'transfer',
        name: 'orderServicerTransfer',
        component: () => import('@/views/orderServicer/orderServicerTransfer.vue'),
        meta: {
          title: '转单列表',
          Permissions: permissions.ServerOrderTurnOrder,
          hidden: true
        }
      }, {
        path: 'outsource',
        name: 'orderServicerOutsource',
        component: () => import('@/views/orderServicer/orderServicerOutsource.vue'),
        meta: {
          title: '委外中',
          Permissions: permissions.ServerOrderOutSource,
          hidden: true
        }
      }, {
        path: 'recycle',
        name: 'orderServicerRecycle',
        component: () => import('@/views/orderServicer/orderServicerRecycle.vue'),
        meta: {
          title: '回收站',
          Permissions: permissions.ServerOrderAllOrder,
          hidden: true
        }
      }]
    }, {
      path: '/OrderComplaint',
      component: Submenu,
      name: 'orderComplaint',
      meta: {
        title: '投诉工单',
        icon: 'ordercomplaint',
        Permissions: permissions.ComplaintOrder,
        hidden: true
      },
      children: [
        {
          path: 'untreated',
          name: 'OrderComplaintUntreated',
          component: () => import('@/views/orderComplaint/OrderComplaintUntreated.vue'),
          meta: {
            title: '未处理',
            Permissions: permissions.ComplaintOrder,
            hidden: true
          }
        }, {
          path: 'underway',
          name: 'OrderComplaintUnderway',
          component: () => import('@/views/orderComplaint/OrderComplaintUnderway.vue'),
          meta: {
            title: '进行中',
            Permissions: permissions.ComplaintOrder,
            hidden: true
          }
        }, {
          path: 'finish',
          name: 'OrderComplaintFinish',
          component: () => import('@/views/orderComplaint/OrderComplaintFinish.vue'),
          meta: {
            title: '已完成',
            Permissions: permissions.ComplaintOrder,
            hidden: true
          }
        }
      ]
    }]
  },
  {
    path: '/Task',
    type: '10',
    component: Layout,
    name: 'Task',
    meta: {
      title: '任务列表',
      icon: 'task',
      Permissions: permissions.OrderTask,
      hidden: true
    },
    children: [{
      path: '/Task',
      component: Submenu,
      meta: {
        title: '我的任务',
        icon: 'task',
        Permissions: permissions.OrderTask,
        hidden: true
      },
      children: [
        {
          path: 'list',
          name: 'TaskList',
          type: 'block',
          component: () => import('@/views/task/TaskList.vue'),
          meta: {
            title: '所有任务',
            Permissions: permissions.OrderTaskList,
            hidden: true
          }
        }, {
          path: 'untreated',
          name: 'TaskListUntreated',
          component: () => import('@/views/task/TaskListUntreated.vue'),
          meta: {
            title: '待处理',
            Permissions: permissions.OrderTaskList,
            hidden: true
          }
        }, {
          path: 'underway',
          name: 'TaskListUnderway',
          component: () => import('@/views/task/TaskListUnderway.vue'),
          meta: {
            title: '进行中',
            Permissions: permissions.OrderTaskList,
            hidden: true
          }
        }, {
          path: 'completed',
          name: 'TaskListCompleted',
          component: () => import('@/views/task/TaskListCompleted.vue'),
          meta: {
            title: '已完成',
            Permissions: permissions.OrderTaskList,
            hidden: true
          }
        }, {
          path: 'report',
          name: 'TaskReport',
          component: () => import('@/views/task/TaskReport.vue'),
          meta: {
            title: '已上报',
            Permissions: permissions.OrderTaskList,
            hidden: true
          }
        }, {
          path: 'transfer',
          name: 'taskTransfer',
          component: () => import('@/views/task/taskTransfer.vue'),
          meta: {
            title: '已转派',
            Permissions: permissions.OrderTaskList,
            hidden: true
          }
        }, {
          path: 'todealing',
          name: 'TaskTodealNew',
          component: () => import('@/views/task/TaskTodealNew.vue'),
          meta: {
            title: '处理任务',
            hidden: true
          }
        }, {
          path: 'todetail',
          name: 'TaskToDetail',
          component: () => import('@/views/task/TaskToDetail.vue'),
          meta: {
            title: '任务详情',
            hidden: true

          }
        }
      ]}
    ]
  },
  // 巡检计划
  {
    path: '/OrderPolling',
    component: Layout,
    meta: {
      title: '巡检管理',
      icon: 'orderpolling',
      Permissions: permissions.PollingOrder,
      hidden: true
    },
    children: [{
      path: 'OrderPollingOnce',
      name: 'OrderPollingOnce',
      type: 'block',
      component: () => import('@/views/orderpolling/OrderPollingOnce.vue'),
      meta: {
        title: '添加巡检单',
        Permissions: permissions.PollingOrderAddOnce,
        hidden: true
      }
    }, {
      path: 'add',
      name: 'OrderPollingAdd',
      type: 'block',
      component: () => import('@/views/orderpolling/OrderPollingAdd.vue'),
      meta: {
        title: '添加巡检计划',
        Permissions: permissions.PollingOrderList,
        hidden: true
      }
    }, {
      path: 'list',
      name: 'OrderPollingList',
      type: 'block',
      component: () => import('@/views/orderpolling/OrderPollingList.vue'),
      meta: {
        title: '所有巡检计划',
        Permissions: permissions.PollingOrderList,
        hidden: true
      }
    }, {
      path: 'check',
      name: 'OrderPollingCheck',
      type: 'block',
      component: () => import('@/views/orderpolling/OrderPollingCheck.vue'),
      meta: {
        title: '检查项设置',
        Permissions: permissions.PollingOrderCheck,
        hidden: true
      }
    }, {
      path: 'event',
      name: 'OrderPollingEvent',
      type: 'block',
      component: () => import('@/views/orderpolling/OrderPollingEvent.vue'),
      meta: {
        title: '巡检事件管理',
        Permissions: permissions.PollingOrderEven,
        hidden: true
      }
    },
    {
      path: 'SettingOrderPolling',
      name: 'SettingOrderPolling',
      type: 'block',
      component: () => import('@/views/system/SettingOrderPolling.vue'),
      meta: {
        title: '巡检设置',
        Permissions: permissions.PollingOrderSeting,
        hidden: true
      }
    }
    ]
  },
  // 安装交付
  {
    path: '/OrderInstallAplay',
    component: Layout,
    meta: {
      title: '安装交付',
      icon: 'orderservicer',
      Permissions: permissions.OrderInstallAplay,
      hidden: true
    },
    children: [
      {
        path: 'OrderInstallAplayAdd',
        name: 'OrderInstallAplayAdd',
        component: () => import('@/views/orderinstallAplay/orderinstallAplayAdd.vue'),
        meta: {
          title: '申领安装',
          Permissions: permissions.OrderInstallAplayAdd,
          hidden: true
        }
      },
    ]
  },
  // 安装管理
  {
    path: '/OrderInstall',
    component: Layout,
    meta: {
      title: '安装管理',
      icon: 'orderinstall',
      Permissions: permissions.OrderInstall,
      hidden: true
    },
    children: [
      {
        path: 'OrderInstallAdd',
        name: 'OrderInstallAdd',
        type: 'block',
        component: () => import('@/views/orderinstall/OrderInstallAdd.vue'),
        meta: {
          title: '添加安装单',
          Permissions: permissions.OrderInstallAdd,
          hidden: true
        }
      },
      // 安装单管理--预设订单来源
      {
        path: 'OrderInstallSource',
        name: 'OrderInstallSource',
        type: 'block',
        component: () => import('@/views/orderinstall/OrderInstallSource.vue'),
        meta: {
          title: '预设订单来源',
          Permissions: permissions.OrderInstallSource,
          hidden: true
        }
      },
      // 权限拆分--系统设置 订单设置 中的 安装单
      {
        path: 'SettingOrderInstall',
        name: 'SettingOrderInstall',
        type: 'block',
        component: () => import('@/views/system/SettingOrderInstall.vue'),
        meta: {
          title: '系统设置',
          Permissions: permissions.OrderInstallSetting,
          hidden: true
        }
      }
    ]
  },
  // 自动推单
  {
    path: '/GroupsPush',
    component: Layout,
    meta: {
      title: '自动推单',
      icon: 'groupspush',
      Permissions: permissions.GroupPush,
      hidden: true
    },
    children: [
      {
        path: 'customer',
        name: 'GroupsPushCustomer',
        component: () => import('@/views/groups/GroupsPushCustomer.vue'),
        meta: {
          title: '客户推单群组',
          Permissions: permissions.GroupPushCustomer,
          hidden: true
        }
      },
      {
        path: 'address',
        name: 'GroupsPushAddress',
        component: () => import('@/views/groups/GroupsPushAddress.vue'),
        meta: {
          title: '地址推单',
          Permissions: permissions.GroupPushAddress,
          hidden: true
        }
      },
      {
        path: 'fault',
        name: 'GroupsPushFault',
        component: () => import('@/views/groups/GroupsPushFault.vue'),
        meta: {
          title: '故障现象推单',
          Permissions: permissions.GroupPushFault,
          hidden: true
        }
      },
      {
        path: 'tag',
        name: 'GroupsPushTag',
        component: () => import('@/views/groups/GroupsPushTag.vue'),
        meta: {
          title: '标签推单群组',
          Permissions: permissions.GroupPushTags,
          hidden: true
        }
      },
      {
        path: 'combine',
        name: 'GroupsPushCombine',
        component: () => import('@/views/groups/GroupsPushCombine.vue'),
        meta: {
          title: '组合推单群组',
          Permissions: permissions.GroupPushCombine,
          hidden: true
        }
      },
      {
        path: 'GroupsPushDepartment',
        name: 'GroupsPushDepartment',
        component: () => import('@/views/groups/GroupsPushDepartment.vue'),
        meta: {
          title: '报修部门推单',
          Permissions: permissions.GroupPushCustomerDept,
          hidden: true
        }
      }
    ]
  },
  // 轨迹展示
  {
    path: '/OrderTrack',
    name: 'OrderTrack',
    meta: {
      title: '轨迹展示',
      hidden: true
    },
    component: () => import('@/views/orderTrack/index.vue')
  },
  // 行程轨迹
  {
    path: '/TaskTrack',
    name: 'TaskTrack',
    meta: {
      title: '行程轨迹',
      hidden: true
    },
    component: () => import('@/views/taskTrack/index.vue')
  },
  // 点检管理
  {
    path: '/cyclCheck',
    component: Layout,
    meta: {
      title: '点检管理',
      icon: 'cyclcheck',
      Permissions: permissions.CyclCheck,
      hidden: true
    },
    children: [
      {
        path: 'even',
        name: 'CyclCheckEven',
        component: () => import('@/views/cyclCheck/CyclCheckEven.vue'),
        meta: {
          title: '点检事件',
          Permissions: permissions.CyclCheck,
          hidden: true
        }
      },
      {
        path: 'job',
        name: 'CyclCheckJob',
        component: () => import('@/views/cyclCheck/CyclCheckJob.vue'),
        meta: {
          title: '点检记录',
          Permissions: permissions.CyclCheck,
          hidden: true
        }
      },
      {
        path: 'record',
        name: 'CyclCheckRecord',
        component: () => import('@/views/cyclCheck/CyclCheckRecord.vue'),
        meta: {
          title: '点检记录',
          hidden: true
        }
      }
    ]
  },

  // 项目管理
  {
    path: '/ProjectAll',
    component: Layout,
    meta: {
      title: (UserModule.getCompany.project_alias ? UserModule.getCompany.project_alias : '项目') + '管理',
      icon: 'project',
      Permissions: permissions.Project,
      hidden: true
    },
    children: [
      {
        path: 'setting',
        name: 'ProjectSetting',
        component: () => import('@/views/project/ProjectSetting.vue'),
        meta: {
          title: (UserModule.getCompany.project_alias ? UserModule.getCompany.project_alias : '项目') + '设置',
          Permissions: permissions.ProjectSeting,
          hidden: true
        }
      },
      {
        path: 'added',
        name: 'ProjectAdded',
        component: () => import('@/views/project/ProjectAdded.vue'),
        meta: {
          title: '创建' + (UserModule.getCompany.project_alias ? UserModule.getCompany.project_alias : '项目'),
          Permissions: permissions.ProjectCreate,
          hidden: true
        }
      },
      {
        path: 'all',
        name: 'AllProject',
        component: () => import('@/views/project/ProjectAll.vue'),
        meta: {
          title: '所有' + (UserModule.getCompany.project_alias ? UserModule.getCompany.project_alias : '项目'),
          Permissions: permissions.ProjectAll,
          hidden: true
        }
      },
      {
        path: 'mine',
        name: 'MyProject',
        component: () => import('@/views/project/ProjectMy.vue'),
        meta: {
          title: '我的' + (UserModule.getCompany.project_alias ? UserModule.getCompany.project_alias : '项目'),
          Permissions: permissions.ProjectMy,
          hidden: true
        }
      },
      {
        path: 'recycle',
        name: ' RecycleProject',
        component: () => import('@/views/project/ProjectRecycle.vue'),
        meta: {
          title: '回收站',
          hidden: true,
          Permissions: permissions.projectRecycle
        }
      }

    ]
  },
  // 客户管理
  {
    path: '/CustomerAll',
    type: '10',
    component: Layout,
    meta: {
      title: '客户管理',
      icon: 'customer',
      Permissions: permissions.CustomerAll,
      hidden: true
    },
    children: [
      {
        path: '/Customer',
        component: Submenu,
        name: 'Customer',
        meta: {
          title: '客户管理',
          icon: 'customer',
          Permissions: permissions.Customer,
          hidden: true
        },
        children: [
          {
            path: 'list',
            name: 'CustomerList',
            component: () => import('@/views/customer/CustomerListLevelByLevel.vue'),
            meta: {
              title: '所有客户',
              Permissions: permissions.Customer,
              hidden: true
            }
          },
          {
            path: 'CustomerTag',
            name: 'CustomerTag',
            component: () => import('@/views/customer/CustomerTag.vue'),
            meta: {
              title: '客户标识',
              Permissions: permissions.Customer,
              hidden: true
            }
          }, {
            path: 'Added',
            name: 'CustomerAdded',
            component: () => import('@/views/customer/CustomerAdded.vue'),
            meta: {
              title: '我添加的',
              Permissions: permissions.Customer,
              hidden: true
            }
          }, {
            path: 'AddedMe',
            name: 'CustomerAddedMe',
            component: () => import('@/views/customer/CustomerAddedMe.vue'),
            meta: {
              title: '添加我的',
              Permissions: permissions.Customer,
              hidden: true
            }
          }, {
            path: 'groupsView',
            name: 'CustomerGroupsView',
            component: () => import('@/views/customer/CustomerGroupsView.vue'),
            meta: {
              title: '客户群组',
              Permissions: permissions.Customer,
              hidden: true
            }
          },
          {
            path: 'groupsAlias',
            name: 'CustomerGroupsAlias',
            component: () => import('@/views/customer/CustomerGroupsAlias.vue'),
            meta: {
              title: '对客别名群组',
              Permissions: permissions.CustomerAliasGroup,
              hidden: true
            }
          },
          {
            path: 'toCustomer',
            name: 'CustomerAddedFrom',
            component: () => import('@/views/customer/CustomerAddedFrom.vue'),
            meta: {
              title: '添加为客户',
              hidden: true
            }
          }
        ]
      },
      {
        path: '/CustomeRelated',
        component: Submenu,
        name: 'CustomeRelated',
        meta: {
          title: '客户关联',
          icon: 'customerelated',
          Permissions: permissions.CustomerRelation,
          hidden: true
        },
        children: [
          {
            path: 'list',
            name: 'CustomeRelatedList',
            component: () => import('@/views/customerRelated/CustomerRelated.vue'),
            meta: {
              title: '关联客户',
              Permissions: permissions.CustomerRelationRelation,
              hidden: true
            }
          },
          {
            path: 'CustomeRelatedOrder',
            name: 'CustomeRelatedOrder',
            component: () => import('@/views/customerRelated/CustomerRelatedOrder.vue'),
            meta: {
              title: '客户订单',
              Permissions: permissions.CustomerRelationRelationOrder,
              hidden: true
            }
          }
        ]
      }]
  },
  // 公司管理 === 人员管理，考勤签到，服务方管理，分公司管理，公司公告
  {
    path: '/company',
    component: Layout,
    type: '10',
    meta: {
      title: '公司管理',
      icon: 'staff',
      Permissions: permissions.Company,
      hidden: true
    },
    children: [{
      path: '/Staff',
      component: Submenu,
      name: 'Staff',
      meta: {
        title: '人员管理',
        icon: 'staff',
        Permissions: permissions.staff,
        hidden: true
      },
      children: [
        {
          path: 'all',
          name: 'StaffAll',
          component: () => import('@/views/staff/StaffAll.vue'),
          meta: {
            title: '人员列表',
            Permissions: permissions.staffAll,
            hidden: true
          }
        }, {
          path: 'role',
          name: 'StaffRole',
          component: () => import('@/views/staff/StaffRole.vue'),
          meta: {
            title: '角色管理',
            Permissions: permissions.staffRole,
            hidden: true
          }
        }, {
          path: 'department',
          name: 'StaffDepartment',
          component: () => import('@/views/staff/StaffDepartment.vue'),
          meta: {
            title: '部门管理',
            Permissions: permissions.staffDepatment,
            hidden: true
          }
        }, {
          path: 'status',
          name: 'StaffStatus',
          component: () => import('@/views/staff/StaffStatus.vue'),
          meta: {
            title: '状态管理',
            Permissions: permissions.staff,
            hidden: true
          }
        }, {
          path: 'autoAssign',
          name: 'AutoAssign',
          component: () => import('@/views/staff/AutoAssign.vue'),
          meta: {
            title: '自动轮派',
            Permissions: permissions.staffAutoAssign,
            hidden: true
          }
        }, {
          path: 'scheduling',
          name: 'StaffScheduling',
          component: () => import('@/views/staff/StaffScheduling.vue'),
          meta: {
            title: '排班管理',
            Permissions: permissions.staffScheduling,
            hidden: true
          }
        },
        {
          path: 'syncrecord',
          name: 'StaffSyncrecord',
          component: () => import('@/views/staff/StaffSyncrecord.vue'),
          meta: {
            title: '同步记录',
            hidden: true
          }
        }
      ]
    },
    {
      path: '/ClockIn',
      component: Submenu,
      name: 'ClockIn',
      meta: {
        title: '考勤签到',
        icon: 'clockin',
        Permissions: permissions.PunchTheClock,
        hidden: true
      },
      children: [
        {
          path: 'list',
          name: 'ClockInList',
          component: () => import('@/views/clockIn/ClockInList.vue'),
          meta: {
            title: '考勤记录',
            Permissions: permissions.PunchTheClockRecord,
            hidden: true
          }
        }, {
          path: 'setting',
          name: 'ClockInSetting',
          component: () => import('@/views/clockIn/ClockInSetting.vue'),
          meta: {
            title: '考勤设置',
            Permissions: permissions.PunchTheClockSetting,
            hidden: true
          }
        }
      ]
    },
    {
      path: '/Kpi',
      component: Submenu,
      name: 'Kpi',
      meta: {
        title: '绩效管理',
        icon: 'kpi',
        Permissions: permissions.Kpi,
        hidden: true
      },
      children: [
       {
          path: 'setting',
          name: 'KpiSetting',
          component: () => import('@/views/kpi/KpiSetting.vue'),
          meta: {
            title: '绩效设置',
            Permissions: permissions.KpiSetting,
            hidden: true
          }
        }
      ]
    },
    {
      path: '/service',
      component: Submenu,
      meta: {
        title: '服务方管理',
        icon: 'servicer',
        Permissions: permissions.Server,
        hidden: true
      },
      children: [
        {
          path: 'myservice',
          name: 'MyService',
          component: () => import('@/views/myService/MyService.vue'),
          meta: {
            title: '我添加的',
            Permissions: permissions.Server,
            hidden: true
          }
        }, {
          path: 'addmeservice',
          name: 'AddMeService',
          component: () => import('@/views/myService/AddMeService.vue'),
          meta: {
            title: '添加我的',
            Permissions: permissions.Server,
            hidden: true
          }
        }
      ]
    },
    {
      path: '/Branch',
      component: Submenu,
      meta: {
        title: '分公司管理',
        icon: 'branch',
        Permissions: permissions.Bruanch,
        hidden: true
      },
      children: [
        {
          path: 'all',
          name: 'BranchAll',
          component: () => import('@/views/branch/BranchAll.vue'),
          meta: {
            title: '分公司列表',
            Permissions: permissions.BruanchCompanyList,
            hidden: true
          }
        },
        {
          path: 'BranchCustomerGroups',
          name: 'BranchOrderCustomerGroups',
          component: () => import('@/views/branch/BranchCustomerGroups.vue'),
          meta: {
            title: '查看报修群组',
            Permissions: permissions.BruanchOrderCusGroup,
            hidden: true
          }
        },
        {
          path: 'orderCustomer',
          name: 'BranchOrderCustomer',
          component: () => import('@/views/branch/BranchOrderCustomer.vue'),
          meta: {
            title: '分公司报修单',
            Permissions: permissions.BruanchOrderCusOrder,
            hidden: true
          }
        },
        {
          path: 'customerStatistics',
          name: 'BranchCustomerStatistics',
          component: () => import('@/views/branch/BranchCustomerStatistics.vue'),
          meta: {
            title: '分公司报修统计',
            Permissions: permissions.BruanchOrderCusOrder,
            hidden: true
          }
        },
        {
          path: 'customerStatisticsBranch',
          name: 'BranchCustomerStatisticsBranch',
          component: () => import('@/views/branch/BranchCustomerStatisticsBranch.vue'),
          meta: {
            title: '分公司报修统计',
            hidden: true
          }
        },
        {
          path: 'orderServicer',
          name: 'BranchOrderServicer',
          component: () => import('@/views/branch/BranchOrderServicer.vue'),
          meta: {
            title: '分公司维修单',
            Permissions: permissions.BruanchOrderSerOrder,
            hidden: true
          }
        },
        {
          path: 'servicer',
          name: 'BranchServicer',
          component: () => import('@/views/branch/BranchServicer.vue'),
          meta: {
            title: '分公司服务方',
            Permissions: permissions.BranchOrderServicer,
            hidden: true
          }
        },
        {
          path: 'checkRecord',
          name: 'BranchCheckRecord',
          component: () => import('@/views/branch/BranchCheckRecordAlone.vue'),
          meta: {
            title: '分公司点检记录',
            Permissions: permissions.BruanchOrderDayCheck,
            hidden: true
          }
        },
        {
          path: 'branchCheckRecordListAlone',
          name: 'BranchCheckRecordListAlone',
          component: () => import('@/views/branch/BranchCheckRecordListAlone.vue'),
          meta: {
            title: '点检记录统计',
            hidden: true
          }
        },
        {
          path: 'checkRecordList',
          name: 'BranchCheckRecordList',
          component: () => import('@/views/branch/BranchCheckRecordList.vue'),
          meta: {
            title: '分公司点检历史记录',
            hidden: true
          }
        }
      ]
    },
    {
      path: '/Announcements',
      component: Submenu,
      meta: {
        title: '公司公告',
        icon: 'announcements',
        Permissions: permissions.CompanyNotice,
        hidden: true
      },
      children: [
        {
          path: 'inner',
          name: 'AnnouncementsListInner',
          component: () => import('@/views/announcements/inner.vue'),
          meta: {
            title: '内部公告',
            Permissions: permissions.CompanyNoticeInner,
            hidden: true
          }
        }, {
          path: 'list',
          name: 'AnnouncementsList',
          component: () => import('@/views/announcements/index.vue'),
          meta: {
            title: '客户公告',
            Permissions: permissions.CompanyCustomerNotice,
            hidden: true
          }
        }
      ]
    }]
  },
  // 备件管理
  {
    path: '/Parts',
    component: Layout,
    meta: {
      title: '备件管理',
      icon: 'parts',
      hidden: true,
      Permissions: permissions.Part
    },
    children: [
      {
        path: 'mine',
        name: 'PartsMine',
        component: () => import('@/views/parts/PartsMine.vue'),
        meta: {
          title: '我的备件',
          Permissions: permissions.Part,
          hidden: true
        }
      },
      {
        path: 'property',
        name: 'PartsProperty',
        component: () => import('@/views/parts/PartsProperty.vue'),
        meta: {
          title: '备件属性',
          Permissions: permissions.Part,
          hidden: true
        }
      },
      {
        path: 'groups',
        name: 'PartsGroups',
        component: () => import('@/views/parts/PartsGroups.vue'),
        meta: {
          title: '查看备件群组',
          Permissions: permissions.Part,
          hidden: true
        }
      },
    ]
  },
  // 库存管理
  {
    path: '/Stock',
    component: Layout,
    meta: {
      title: '库存管理',
      icon: 'stock',
      Permissions: permissions.Stock,
      hidden: true
    },
    children: [
      {
        path: 'index',
        name: 'StockIndex',
        component: () => import('@/views/stock/StockIndex.vue'),
        meta: {
          title: '库存台账',
          Permissions: permissions.StockTz,
          hidden: true
        }
      },
      {
        path: 'inoutProcessing',
        name: 'StockInoutProcessing',
        component: () => import('@/views/stock/StockInoutProcessing.vue'),
        meta: {
          title: '员工领退处理',
          Permissions: permissions.StockApplyInoutRecord,
          hidden: true
        }
      },
      {
        path: 'check',
        name: 'StockCheck',
        component: () => import('@/views/stock/StockCheck.vue'),
        meta: {
          title: '库存盘点',
          Permissions: permissions.StockCheck,
          hidden: true
        }
      },
      {
        path: 'inout',
        name: 'StockInout',
        component: () => import('@/views/stock/StockInout.vue'),
        meta: {
          title: '出入库记录',
          Permissions: permissions.StockInOutRecord,
          hidden: true
        }
      },
      {
        path: 'inoutStatistics',
        name: 'StockInoutStatistics',
        component: () => import('@/views/stock/StockInoutStatistics.vue'),
        meta: {
          title: '出入库统计',
          Permissions: permissions.StockInOutRecord,
          hidden: true
        }
      },
      {
        path: 'personStatistics',
        name: 'StockPersonStatistics',
        component: () => import('@/views/stock/StockPersonStatistics.vue'),
        meta: {
          title: '个人统计',
          Permissions: permissions.StockInOutRecord,
          hidden: true
        }
      },
      {
        path: 'customerStatistics',
        name: 'StockCustomerStatistics',
        component: () => import('@/views/stock/StockCustomerStatistics.vue'),
        meta: {
          title: '客户统计',
          Permissions: permissions.Customer,
          hidden: true
        }
      },
      {
        path: 'setting',
        name: 'StockSetting',
        component: () => import('@/views/stock/StockSetting.vue'),
        meta: {
          title: '库存设置',
          Permissions: permissions.Stocksetting,
          hidden: true
        }
      },
      {
        path: 'verification',
        name: 'StockVerification',
        component: () => import('@/views/stock/StockVerification.vue'),
        meta: {
          title: '库存核销',
          hidden: true
        }
      },
      {
        path: 'inStock',
        name: 'StockIn',
        component: () => import('@/views/stock/StockIn.vue'),
        meta: {
          title: '入库登记',
          hidden: true
        }
      },
      {
        path: 'chargeOff',
        name: 'StockChargeOffList',
        component: () => import('@/views/stock/StockChargeOffList.vue'),
        meta: {
          title: '入库登记',
          hidden: true
        }
      },
      {
        path: 'outStock',
        name: 'StockOut',
        component: () => import('@/views/stock/StockOut.vue'),
        meta: {
          title: '出库登记',
          hidden: true
        }
      },
      {
        path: 'checkRecord',
        name: 'StockCheckRecord',
        component: () => import('@/views/stock/StockCheckRecord.vue'),
        meta: {
          title: '盘点记录',
          hidden: true
        }
      }
    ]
  },
  // 产品管理
  {
    path: '/Device',
    type: '10',
    component: Layout,
    meta: {
      title: '设备管理',
      icon: 'device',
      Permissions: permissions.Device,
      hidden: true
    },
    children: [
      {
        path: '/Device',
        component: Submenu,
        type: '-999999',
        meta: {
          title: '',
          icon: 'device',
          Permissions: permissions.Device1,
          hidden: true
        },
        children: [
          {
            path: 'toBrand',
            name: 'DeviceToBrand',
            component: () => import('@/views/device/ToBrand.vue'),
            meta: {
              title: '品牌管理',
              Permissions: permissions.ProductBrand,
              hidden: true
            }
          },
          {
            path: 'toDevice',
            name: 'DeviceToDevice',
            component: () => import('@/views/device/ToDevice.vue'),
            meta: {
              title: '设备管理',
              Permissions: permissions.ProductDevice,
              hidden: true
            }
          }, {
            path: 'addDevice',
            name: 'DeviceADDDevice',
            component: () => import('@/views/device/addDevice.vue'),
            meta: {
              title: '添加设备',
              hidden: true
            }
          }
        ]
      },
      {
        path: 'Device',
        component: Submenu,
        meta: {
          title: '',
          icon: 'device',
          Permissions: permissions.ProductAuth,
          hidden: true
        },
        children: [
          {
            path: 'toCustomer',
            name: 'DeviceToCustomer',
            component: () => import('@/views/device/ToCustomer.vue'),
            meta: {
              title: '授权客户的设备',
              Permissions: permissions.ProductAuth,
              hidden: true
            }
          },
          {
            path: 'toMeCustomer',
            name: 'DeviceToMeCustomer',
            component: () => import('@/views/device/ToMeCustomer.vue'),
            meta: {
              title: '客户授权我的设备',
              Permissions: permissions.ProductAuth,
              hidden: true
            }
          }]
      },
      {
        path: 'Device',
        component: Submenu,
        meta: {
          title: '',
          icon: 'device',
          Permissions: permissions.ProductAuthSer,
          hidden: true
        },
        children: [{
          path: 'toServicer',
          name: 'DeviceToServicer',
          component: () => import('@/views/device/Toservicer.vue'),
          meta: {
            title: '授权服务方的设备',
            Permissions: permissions.ProductAuthSer,
            hidden: true
          }
        },
        {
          path: 'toMeServicer',
          name: 'DeviceToMeServicer',
          component: () => import('@/views/device/TomeServicer.vue'),
          meta: {
            title: '服务方授权我的设备',
            Permissions: permissions.ProductAuthSer,
            hidden: true
          }
        }]
      }]
  },
  // 知识库
  {
    path: '/KnowledgeBase',
    component: Layout,
    meta: {
      title: '知识库',
      icon: 'knowledge',
      Permissions: permissions.KnowledgeBase,
      hidden: true
    },
    children: [
      {
        path: 'index',
        name: 'KnowledgeBase',
        component: () => import('@/views/knowledge/knowledgeBase.vue'),
        meta: {
          title: '知识库管理',
          Permissions: permissions.KnowledgeSetting,
          hidden: true
        }
      },
      {
        path: 'view',
        name: 'KnowledgeView',
        component: () => import('@/views/knowledge/knowledgeView.vue'),
        meta: {
          title: '查看知识库',
          Permissions: permissions.KnowledgeLook,
          hidden: true
        }
      },
      {
        path: 'add',
        name: 'KnowledgeAddDocument',
        component: () => import('@/views/knowledge/knowledgeAdd.vue'),
        meta: {
          title: '新建文档',
          hidden: true
        }
      },
      {
        path: 'details',
        name: 'KnowledgeDetails',
        component: () => import('@/views/knowledge/knowledgeDetails.vue'),
        meta: {
          title: '详情',
          hidden: true
        }
      }
    ]
  },
  // 统计报表
  {
    path: '/Statistics',
    component: Layout,
    meta: {
      title: '统计报表',
      icon: 'statistics',
      Permissions: permissions.Statistics,
      hidden: true
    },
    children: [
      {
        path: 'staff',
        name: 'StatisticsStaff',
        component: () => import('@/views/statistics/Staff.vue'),
        meta: {
          title: '人员统计',
          Permissions: permissions.StatisticsPerson,
          hidden: true
        }
      },
      {
        path: 'staffTask',
        name: 'StatisticsStaffTask',
        component: () => import('@/views/statistics/StaffTask.vue'),
        meta: {
          title: '任务详情',
          hidden: true
        }
      },
      {
        path: 'engineer',
        name: 'StatisticsEngineer',
        component: () => import('@/views/statistics/Sengineer.vue'),
        meta: {
          title: '工程师报表',
          Permissions: permissions.StatisticsPerson,
          hidden: true
        }
      },
      {
        path: 'deptCusOrder',
        name: 'StatisticsDeptCusOrder',
        component: () => import('@/views/statistics/SdeptCusOrder.vue'),
        meta: {
          title: '报修部门工单',
          Permissions: permissions.StatisticsDeptCusOrder,
          hidden: true
        }
      },
      {
        path: 'deptSerOrder',
        name: 'StatisticsDeptSerOrder',
        component: () => import('@/views/statistics/SdeptSerOrder.vue'),
        meta: {
          title: '服务部门工单',
          Permissions: permissions.StatisticsDeptSerOrder,
          hidden: true
        }
      },
      {
        path: 'customer',
        name: 'StatisticsCustomer',
        component: () => import('@/views/statistics/Scustomer.vue'),
        meta: {
          title: '客户统计',
          Permissions: permissions.StatisticsCusOrder,
          hidden: true
        }
      },
      {
        path: 'cusPrice',
        name: 'StatisticsCusPrice',
        component: () => import('@/views/statistics/ScusPrice.vue'),
        meta: {
          title: '客户费用',
          Permissions: permissions.StatisticsCusPrice,
          hidden: true
        }
      },
      {
        path: 'deptCusPrice',
        name: 'StatisticsDeptCusPrice',
        component: () => import('@/views/statistics/SdeptCusPrice.vue'),
        meta: {
          title: '报修部门费用',
          Permissions: permissions.StatisticsDeptCusPrice,
          hidden: true
        }
      },
      {
        path: 'deptSerPrice',
        name: 'StatisticsDeptSerPrice',
        component: () => import('@/views/statistics/SdeptSerPrice.vue'),
        meta: {
          title: '服务部门费用',
          Permissions: permissions.StatisticsDeptSerPrice,
          hidden: true
        }
      },
      {
        path: 'parts',
        name: 'StatisticsParts',
        component: () => import('@/views/statistics/Sparts.vue'),
        meta: {
          title: '备件报表',
          Permissions: permissions.StatisticsParts,
          hidden: true
        }
      },
      {
        path: 'device',
        name: 'StatisticsDevice',
        component: () => import('@/views/statistics/Sdevice.vue'),
        meta: {
          title: '设备报表',
          Permissions: permissions.StatisticsDevice,
          hidden: true
        }
      },
      {
        path: 'falutPhenomenon',
        name: 'FalutPhenomenon',
        component: () => import('@/views/statistics/SfaultType.vue'),
        // query:{
        //   faultType:2,
        //   pFaultTypeId:0,
        // },
        meta: {
          title: '故障现象',
          Permissions: permissions.StatisticsFaultPhenomenon,
          hidden: true
        }
      },
      {
        path: 'faultType',
        name: 'FaultType',
        component: () => import('@/views/statistics/SfaultType.vue'),
        // query:{
        //   faultType:1,
        //   pFaultTypeId:0,
        // },
        meta: {
          title: '故障类型',
          Permissions: permissions.StatisticsFalultType,
          hidden: true
        }
      },
      {
        path: 'customerDetail',
        name: 'StatisticsCustomerDetail',
        component: () => import('@/views/statistics/ScustomerDetail.vue'),
        meta: {
          title: '客户统计详情',
          hidden: true
        }
      },
      {
        path: 'servicer',
        name: 'StatisticsServicer',
        component: () => import('@/views/statistics/Servicer.vue'),
        meta: {
          title: '服务方统计',
          Permissions: permissions.StatisticsServer,
          hidden: true
        }
      },
      {
        path: 'branch',
        name: 'StatisticsServicerBranch',
        component: () => import('@/views/statistics/ServicerBranch.vue'),
        meta: {
          title: '服务方统计',
          hidden: true
        }
      },
      {
        path: 'details',
        name: 'StatisticsServicerDetails',
        component: () => import('@/views/statistics/ServicerDetails.vue'),
        meta: {
          title: '服务方统计',
          hidden: true
        }
      },
      {
        path: 'reportForms',
        name: 'StatisticsReportForms',
        component: () => import('@/views/statistics/SreportForms.vue'),
        meta: {
          title: '自定义报表',
          Permissions: permissions.StatisticsDiyOrder,
          hidden: true
        }
      },
      {
        path: 'deptReportForms',
        name: 'StatisticsDeptReportForms',
        component: () => import('@/views/statistics/SreportForms.vue'),
        meta: {
          title: '部门自定义报表',
          Permissions: permissions.StatisticsSerDeptDiyOrder,
          hidden: true
        }
      },
      {
        path: 'reportTemplate',
        name: 'StatisticsReportTemplate',
        component: () => import('@/views/statistics/SreportTemplate.vue'),
        meta: {
          title: '自定义模板',
          hidden: true
        }
      },
      {
        path: 'screen',
        name: 'StatisticsScreen',
        component: () => import('@/views/statistics/ScreenBig.vue'),
        meta: {
          title: '数据大屏',
          Permissions: permissions.StatisticsBigData,
          hidden: true
        }
      }
    ]
  },
//结算管理
  {
    path: '/Settlement',
    component: Layout,
    meta: {
      title: '结算管理',
      icon: 'statistics',
      Permissions: permissions.Settlement,
      hidden: true
    },
    children: [
      {
        path: 'unsettled',
        name: 'SettlementUnsettled',
        component: () => import('@/views/orderServicer/orderServicerSettlement.vue'),
        meta: {
          title: '未结算',
          Permissions: permissions.SettlementDeal,
          hidden: true
        }
      },
      {
        path: 'settled',
        name: 'SettlementSettled',
        component: () => import('@/views/orderServicer/orderServicerSettlement.vue'),
        meta: {
          title: '已结算',
          Permissions: permissions.SettlementDeal,
          hidden: true
        }
      },
    ]
  },
  // 系统设置
  {
    path: '/System',
    component: Layout,
    meta: {
      title: '系统设置',
      icon: 'system',
      Permissions: permissions.System,
      hidden: true
    },
    children: [
      {
        path: 'base',
        name: 'SettingBase',
        component: () => import('@/views/system/SettingBase.vue'),
        meta: {
          title: '基础设置',
          Permissions: permissions.SystemCompany,
          hidden: true
        }
      },
      {
        path: 'template',
        name: 'SettingTemplateList',
        component: () => import('@/views/system/SettingTemplateList.vue'),
        meta: {
          title: '模板设置',
          Permissions: permissions.Template,
          hidden: true
        }
      },
      {
        path: 'module',
        name: 'SettingModule',
        component: () => import('@/views/system/SettingModule.vue'),
        meta: {
          title: '功能模块',
          Permissions: permissions.SystemModule,
          hidden: true
        }
      },
      {
        path: 'order',
        name: 'SettingOrder',
        component: () => import('@/views/system/SettingOrder.vue'),
        meta: {
          title: '订单设置',
          Permissions: permissions.SystemOrderSetting,
          hidden: true
        }
      },
      {
        path: 'door',
        name: 'doorSetting',
        component: () => import('@/views/system/SettingDoor.vue'),
        meta: {
          title: '服务首页',
          hidden: true,
          Permissions: permissions.ServerIndex
        }
      },
      {
        path: 'setting',
        name: 'TravelPathSetting',
        component: () => import('@/views/path/PathSetting.vue'),
        meta: {
          title: '轨迹设置',
          Permissions: permissions.TrackPathSeting,
          hidden: true
        }
      },
      {
        path: 'log',
        name: 'SettingLog',
        component: () => import('@/views/system/SettingLog.vue'),
        meta: {
          title: '操作日志',
          Permissions: permissions.SystemOperationLog,
          hidden: true
        }
      }
      // {
      //   path: 'develop',
      //   name: 'SettingDevelop',
      //   component: () => import('@/views/system/SettingDevelop.vue'),
      //   meta: {
      //     title: '开发设置',
      //     hidden: true
      //   }
      // }
    ]
  },

  {
    path: '/Record',
    component: Layout,
    meta: {
      title: '',
      icon: '',
      hidden: true

    },
    children: [{
      path: 'list',
      name: 'ListRecord',
      component: () => import('@/views/record/ListRecord.vue'),
      meta: {
        title: '报修履历',
        hidden: true
      }
    },{
      path: 'bbs',
      name: 'bbsListMessage',
      component: () => import('@/views/record/ListMessage.vue'),
      meta: {
        title: '留言列表',
        hidden: true
      }
    }]
  },
  // 自定义导出二维码
  {
    path: '/CustomerQrcodeDownload',
    name: 'CustomerQrcodeDownload',
    component: () => import('@/views/customer/CustomerQrcodeDownload.vue'),
    meta: {
      title: '自定义导出二维码',
      hidden: true,
    }
  },
  {
    path: '/CustomerQrcodeTemplate',
    name: 'CustomerQrcodeTemplate',
    component: () => import('@/views/customer/CustomerQrcodeTemplate.vue'),
    meta: {
      title: '二维码模板',
      hidden: true,
    }
  },
  // 巡检电子工单设置模板设置
  {
    path: '/SystemTemplateSetting',
    name: 'SystemTemplateSetting',
    component: () => import('@/views/system/SettingTemplate.vue'),
    meta: {
      title: '模板设置',
      hidden: true
    }
  },
  // 系统消息
  {
    path: '/Message',
    component: Layout,
    meta: {
      title: '消息',
      icon: '',
      hidden: true
    },
    children: [
      {
        path: 'list',
        name: 'MessageList',
        component: () => import('@/views/message/index.vue'),
        meta: {
          title: '消息列表',
          hidden: true
        }
      }
    ]
  },
  // 账户设置
  {
    path: '/User',
    component: Layout,
    meta: {
      title: '账户设置',
      icon: '',
      hidden: true
    },
    children: [
      {
        path: 'account',
        name: 'UserAccount',
        component: () => import('@/views/user/UserAccount.vue'),
        meta: {
          title: '账户设置',
          hidden: true
        }
      }
    ]
  },
  // 加入单位
  {
    path: '/Company/join',
    component: () => import('@/views/company/CompanyJoin.vue'),
    meta: { title: '加入单位', hidden: true }
  },
  // 创建单位
  {
    path: '/Company/create',
    component: () => import('@/views/company/CompanyCreate.vue'),
    meta: { title: '创建单位', hidden: true }
  },
  // 完善信息
  {
    path: '/Company/complete',
    component: () => import('@/views/company/CompanyComplete.vue'),
    meta: { title: '完善信息', hidden: true }
  },
  // 系统消息
  {
    path: '/VideoCall',
    component: () => import('@/views/videoCall/index.vue'),
    meta: {
      title: '远程视频',
      icon: '',
      hidden: true
    }
  },
  // 导出图片
  {
    path: '/ExportTask',
    name: 'FilesExportTask',
    component: () => import('@/views/files/FilesExport.vue'),
    meta: {
      title: '导出管理',
      hidden: true
    }
  },
  // 导入
  {
    path: '/ImportTask',
    name: 'FilesImportTask',
    component: () => import('@/views/files/FilesImport.vue'),
    meta: {
      title: '导入管理',
      hidden: true
    }
  },
  {
    path: '/Agent',
    name: 'Agent',
    component: layoutAgent,
    meta: {
      title: '代理后台',
      hidden: true
    },
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/agent/index.vue'),
        meta: {
          title: '主页',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
    meta: { hidden: true }
  },
  {
    path: '*',
    redirect: '/404',
    meta: { hidden: true }
  }
];
export default new Router({
  base: process.env.BASE_URL,
  routes: dynamicRoutes
});
